import React from 'react';
import { motion } from 'framer-motion';
import { WINE_PHOTOS } from '../../data/wine';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function WineStory() {
  return <section id="lite-vin" className="w-full border-t border-ink/10" aria-labelledby="litevin-rubrik" data-id="element-304" data-mp="3s6eofmzwn48y">
      {/* Hero */}
      <div className="px-6 pt-20 md:pt-28" data-id="element-305" data-mp="sqi1no6tlhtt">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} variants={{
        visible: {
          transition: {
            staggerChildren: 0.08
          }
        }
      }} className="max-w-6xl mx-auto" data-id="element-306" data-mp="nrx2ls3b146y">
          <motion.p variants={fadeUp} className="font-sans text-[10px] md:text-xs tracking-[0.3em] uppercase text-ink/45" data-id="element-307" data-mp="ez3ed55vqugy">
            Ett vinkoncept av Lilla V
          </motion.p>

          <motion.h2 variants={fadeUp} id="litevin-rubrik" className="mt-5 font-sans text-[4.5rem] sm:text-[7rem] md:text-[10.5rem] font-medium tracking-[-0.05em] uppercase leading-[0.8] text-ink" data-id="element-308" data-mp="16oog1kw60p33">
            Lite Vin
          </motion.h2>

          <motion.p variants={fadeUp} className="mt-8 font-serif text-3xl sm:text-4xl md:text-5xl font-light leading-tight text-ink" data-id="element-309" data-mp="3np2aht6nqlwy">
            Bra vin till bra pris.
          </motion.p>

          <motion.div variants={fadeUp} className="mt-10 flex flex-wrap items-center gap-3" data-id="element-310" data-mp="3jnqtgc1un90d">
            <a href="#boka-bord" className="inline-flex items-center px-8 py-4 rounded-full bg-ink text-white font-sans text-[10px] md:text-xs tracking-[0.2em] uppercase hover:bg-ink/85 transition-colors duration-200" data-id="element-311" data-mp="34r9ivn1hhyev">
              Boka bord
            </a>
            <a href="#vin-pa-glas" className="inline-flex items-center px-8 py-4 rounded-full border border-ink/25 text-ink font-sans text-[10px] md:text-xs tracking-[0.2em] uppercase hover:border-ink transition-colors duration-200" data-id="element-312" data-mp="17yg3f8dbjkfx">
              Se vinlistan
            </a>
          </motion.div>

          <motion.figure variants={fadeUp} className="mt-14 md:mt-20" data-id="element-313" data-mp="wj4mvcvo6jsx">
            <img src={WINE_PHOTOS.hero} alt="Gäster som skålar med olika viner vid ett bord på Lilla V" className="w-full aspect-[16/9] object-cover rounded-sm" loading="lazy" data-id="element-314" data-mp="sikqwcmu1m8d" />
          </motion.figure>
        </motion.div>
      </div>

      {/* Story */}
      <div className="px-6 py-20 md:py-28" data-id="element-315" data-mp="1ffw47grniouc">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} variants={{
        visible: {
          transition: {
            staggerChildren: 0.08
          }
        }
      }} className="max-w-6xl mx-auto" data-id="element-316" data-mp="1bgn9o9osemxq">
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_1fr] gap-x-16 gap-y-12 border-t border-ink/15 pt-12" data-id="element-317" data-mp="2356v86j794va">
            <div className="space-y-8" data-id="element-318" data-mp="3lwe3y7l3jrh0">
              <motion.p variants={fadeUp} className="font-serif text-2xl md:text-[2rem] font-light leading-[1.35] text-ink" data-id="element-319" data-mp="3qscp7mb4otd7">
                Vi var helt enkelt trötta på att alltid behöva köpa en hel
                flaska för att få dricka riktigt bra vin.
              </motion.p>

              <motion.p variants={fadeUp} className="font-sans text-sm md:text-base leading-relaxed text-ink/65" data-id="element-320" data-mp="8n9cbfex7d28">
                På många ställen styr marginalen vilka viner som hamnar på glas.
                Vi tror på motsatsen.
              </motion.p>

              <motion.p variants={fadeUp} className="font-sans text-4xl sm:text-5xl md:text-6xl font-medium tracking-[-0.03em] uppercase leading-[0.95] text-ink" data-id="element-321" data-mp="me4slcrr0wfu">
                Bra vin
                <br data-id="element-322" data-mp="iq3mxm7x95ai" />
                till bra pris.
              </motion.p>

              <motion.figure variants={fadeUp} className="pt-4" data-id="element-323" data-mp="io0ku3thvlpf">
                <img src={WINE_PHOTOS.glasses} alt="Fem glas med olika viner på ett bord i kvällsljus" className="w-full aspect-[4/5] object-cover rounded-sm" loading="lazy" data-id="element-324" data-mp="dqqzp0d51w7e" />
              </motion.figure>
            </div>

            <div className="space-y-8 lg:pt-16" data-id="element-325" data-mp="3vx5cux3l224q">
              <motion.p variants={fadeUp} className="font-sans text-sm md:text-base leading-relaxed text-ink/65" data-id="element-326" data-mp="3qybwmwwwvx0v">
                Därför har vi byggt Lite Vin kring galet bra baspriser på
                riktigt bra vin — och samtidigt en otroligt hög nivå på våra mer
                unika flaskor.
              </motion.p>

              <motion.p variants={fadeUp} className="pl-6 border-l border-ink/25 font-sans text-sm md:text-base leading-relaxed text-ink/65" data-id="element-327" data-mp="1l6oq17e6pkvr">
                Nästan halva vårt sortiment är viner som vanligtvis aldrig hade
                serverats på glas, just för att de inte är
                &rdquo;marginalviner&rdquo;.
              </motion.p>

              <motion.p variants={fadeUp} className="font-sans text-sm md:text-base leading-relaxed text-ink/65" data-id="element-328" data-mp="1eqyadrv9n2o4">
                Vi vill göra vin mer tillgängligt. Inte låsa in det i en fancy
                källare och vänta på rätt tillfälle.
              </motion.p>

              <motion.p variants={fadeUp} className="font-serif italic text-3xl md:text-[2.75rem] font-light leading-[1.15] text-ink" data-id="element-329" data-mp="1xnpmnhce4hio">
                Vin är till för att njutas av.
              </motion.p>

              <motion.figure variants={fadeUp} className="pt-4" data-id="element-330" data-mp="2pdcbymp84wdk">
                <img src={WINE_PHOTOS.board} alt="Delad bricka med ost och chark tillsammans med två glas vin" className="w-full aspect-[4/5] object-cover rounded-sm" loading="lazy" data-id="element-331" data-mp="2u6dvj80dlk3h" />
              </motion.figure>
            </div>
          </div>

          <motion.div variants={fadeUp} className="mt-16 pt-12 border-t border-ink/15 grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-10 items-end" data-id="element-332" data-mp="2uyteqawlygrz">
            <p className="max-w-2xl font-sans text-sm md:text-base leading-relaxed text-ink/65" data-id="element-333" data-mp="2l39s6f3xoufw">
              Så hjälp oss att rotera vinet genom att dricka upp det vi tar in.
              Ju oftare ni dricker upp det, desto mer kommer vi att rotera.
            </p>
            <p className="font-serif text-3xl md:text-5xl font-light text-ink whitespace-nowrap" data-id="element-334" data-mp="27blh8f5f8c0i">
              Win – win <span className="text-ink/40" data-id="element-335" data-mp="22c8pbfzp0er2">;)</span>
            </p>
          </motion.div>

          <motion.p variants={fadeUp} className="mt-16 font-sans text-2xl sm:text-3xl md:text-4xl font-medium tracking-[-0.02em] leading-tight text-ink" data-id="element-336" data-mp="1xcm8yxokiie1">
            Du behöver inte kunna vin.
            <br data-id="element-337" data-mp="1s6h44id4dhu1" />
            <span className="text-ink/40" data-id="element-338" data-mp="1s67g30bmxkqz">Du behöver bara gilla vin.</span>
          </motion.p>
        </motion.div>
      </div>
    </section>;
}